<template>
  <div class="page-title">
    <div class="swiper relative slider-page-title">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div
            v-if="pageTitle.image"
            class="content text-center"
            :style="`background-image: url('${getImageUrl(
              pageTitle.image
            )}'); background-size: cover; background-repeat: no-repeat; background-position: center center;`"
          >
            <div class="themesflat-container">
              <div class="row">
                <div class="col-12">
                  <div class="text" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ pageTitle.page_title }}</div>
                  <div class="heading">{{ pageTitle.description }}</div>
                  <p>
                    {{ pageTitle.small_description }}
                  </p>
                  <router-link to="/menu" class="button-two-line" style="text-transform: uppercase;">{{ $t('discover_menu') }}</router-link>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination style-number page-title-pagination"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "PageTitleComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      langStore,
      pageTitle: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchPageTitle();
    },
  },

  mounted() {
    this.fetchPageTitle();
  },

  methods: {
     async fetchPageTitle() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/page-title`,
          { params: { lang: this.langStore.lang } }
        );

        this.pageTitle = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + encodeURIComponent(photo);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
